module.exports = __webpack_public_path__ + "img/jisushishi_icon.9edc4e46.png";